import ArticleBlockInput from './ArticleBlockInput'
export default ArticleBlockInput;